/**
 * Ilustraciones SVG ligeras + animación por CSS (sin Lottie, sin dependencias).
 */

function wrapIllustration(className: string, svgMarkup: string): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = `sv-audience__art ${className}`;
  wrap.setAttribute('aria-hidden', 'true');
  wrap.innerHTML = svgMarkup;
  return wrap;
}

/** Cliente: app, mapa, pin y chat con movimiento suave. */
export function createClientIllustration(): HTMLElement {
  return wrapIllustration(
    'sv-audience__art--client',
    `<svg class="sv-audience-svg" viewBox="0 0 280 200" xmlns="http://www.w3.org/2000/svg" focusable="false">
  <defs>
    <linearGradient id="audGradClientOrb" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#b388ff" stop-opacity="0.45"/>
      <stop offset="100%" stop-color="#6a1b9a" stop-opacity="0.2"/>
    </linearGradient>
    <linearGradient id="audGradClientPhone" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#faf8fc"/>
      <stop offset="100%" stop-color="#ede7f6"/>
    </linearGradient>
  </defs>
  <ellipse cx="140" cy="108" rx="102" ry="78" fill="url(#audGradClientOrb)"/>
  <g class="sv-aud-ill sv-aud-ill--phone">
    <rect x="96" y="44" width="88" height="124" rx="16" fill="#fff" stroke="#6a1b9a" stroke-width="3"/>
    <rect x="108" y="58" width="64" height="86" rx="8" fill="url(#audGradClientPhone)"/>
    <circle class="sv-aud-ill__pulse" cx="140" cy="100" r="4" fill="#8e24aa"/>
    <path class="sv-aud-ill__route" d="M118 78 L140 92 L162 84 L168 102" fill="none" stroke="#6a1b9a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="118" cy="78" r="6" fill="#43a047" stroke="#fff" stroke-width="2"/>
    <circle cx="168" cy="102" r="6" fill="#e91e63" stroke="#fff" stroke-width="2"/>
    <rect x="124" y="150" width="32" height="4" rx="2" fill="#d1c4e9"/>
  </g>
  <g class="sv-aud-ill sv-aud-ill--pin">
    <path d="M188 36c-9 0-16 7-16 16 0 12 16 32 16 32s16-20 16-32c0-9-7-16-16-16z" fill="#e91e63" stroke="#ad1457" stroke-width="2"/>
    <circle cx="188" cy="50" r="5" fill="#fff"/>
  </g>
  <g class="sv-aud-ill sv-aud-ill--chat">
    <rect x="38" y="118" width="56" height="36" rx="10" fill="#fff" stroke="#6a1b9a" stroke-width="2"/>
    <path d="M58 154l10 10 4-10" fill="#fff" stroke="#6a1b9a" stroke-width="2"/>
    <rect x="48" y="128" width="36" height="4" rx="2" fill="#d1c4e9"/>
    <rect x="48" y="136" width="24" height="4" rx="2" fill="#e1bee7"/>
  </g>
  <g class="sv-aud-ill sv-aud-ill--dots" transform="translate(210, 125)">
    <circle cx="0" cy="0" r="4" fill="#8e24aa"/>
    <circle cx="14" cy="0" r="4" fill="#8e24aa"/>
    <circle cx="28" cy="0" r="4" fill="#8e24aa"/>
  </g>
</svg>`
  );
}

/** Colaborador: figura, llave inglesa, vehículo y moneda. */
export function createCollaboratorIllustration(): HTMLElement {
  return wrapIllustration(
    'sv-audience__art--collab',
    `<svg class="sv-audience-svg" viewBox="0 0 280 200" xmlns="http://www.w3.org/2000/svg" focusable="false">
  <defs>
    <linearGradient id="audGradCollOrb" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#ce93d8" stop-opacity="0.4"/>
      <stop offset="100%" stop-color="#4a148c" stop-opacity="0.25"/>
    </linearGradient>
    <linearGradient id="audGradWrench" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#bdbdbd"/>
      <stop offset="50%" stop-color="#eee"/>
      <stop offset="100%" stop-color="#9e9e9e"/>
    </linearGradient>
  </defs>
  <ellipse cx="140" cy="108" rx="102" ry="78" fill="url(#audGradCollOrb)"/>
  <g class="sv-aud-ill sv-aud-ill--car" opacity="0.45">
    <path d="M32 118h48l10-18h56l10 18h40v24H32v-24z" fill="#b39ddb" stroke="#5e35b1" stroke-width="2"/>
    <circle cx="58" cy="144" r="9" fill="#4a148c"/>
    <circle cx="128" cy="144" r="9" fill="#4a148c"/>
    <circle cx="198" cy="144" r="9" fill="#4a148c"/>
  </g>
  <g class="sv-aud-ill sv-aud-ill--person">
    <circle cx="140" cy="72" r="24" fill="#ffe0b2" stroke="#6a1b9a" stroke-width="2.5"/>
    <path d="M95 108c0-25 20-40 45-40s45 15 45 40v52H95v-52z" fill="#5e35b1" stroke="#4a148c" stroke-width="2"/>
    <path d="M125 98h30v8c0 8-6 14-15 14s-15-6-15-14v-8z" fill="#4527a0"/>
  </g>
  <g transform="translate(155, 78)">
    <g class="sv-aud-ill sv-aud-ill--wrench">
      <path d="M4 18h44l6-8 6 8h18v14H56l-6 8-6-8H4V18z" fill="url(#audGradWrench)" stroke="#616161" stroke-width="1.6" stroke-linejoin="round"/>
      <circle cx="88" cy="25" r="20" fill="url(#audGradWrench)" stroke="#616161" stroke-width="2.2"/>
      <circle cx="88" cy="25" r="9" fill="#4e342e" opacity="0.22"/>
    </g>
  </g>
  <g class="sv-aud-ill sv-aud-ill--coin">
    <circle cx="210" cy="48" r="20" fill="#ffca28" stroke="#f9a825" stroke-width="2.5"/>
    <path d="M210 38v20M202 44h16M202 52h16" stroke="#f57f17" stroke-width="2" stroke-linecap="round"/>
  </g>
  <g class="sv-aud-ill sv-aud-ill--spark" stroke="#ffd54f" stroke-width="2.5" stroke-linecap="round" fill="none">
    <path d="M52 56l8-8M52 48l8 8"/>
    <path d="M230 72l6-6M230 66l6 6"/>
  </g>
</svg>`
  );
}
